<script setup>
import { computed, watch, ref, onUnmounted } from 'vue';
import { useVault } from '../stores/vault.js';

const vault = useVault();
const up = ref(false);
let timer;

watch(() => vault.toast, t => {
  if (!t) { up.value = false; return; }
  up.value = true;
  clearTimeout(timer);
  timer = setTimeout(() => { up.value = false; }, 2600);
});

onUnmounted(() => clearTimeout(timer));

const message = computed(() => vault.toast?.message ?? '');
const undo = computed(() => vault.toast?.undo);

async function runUndo() {
  const fn = undo.value;
  up.value = false;
  if (fn) await fn();
}
</script>

<template>
  <div class="toast" :class="{ up }" role="status" aria-live="polite">
    <span>{{ message }}</span>
    <button v-if="undo" class="mini" @click="runUndo">Undo</button>
  </div>
</template>
